<script>
export default {
  name: "newLoaderIconStyle",
};
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M22.6564 1.78784V7.11584H17.3284"
      stroke="#51526C"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M1.34363 22.2119L1.34363 16.8839L6.67163 16.8839"
      stroke="#51526C"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M0.900146 11.9999C0.900147 9.65581 1.64224 7.37189 3.02006 5.47548C4.39788 3.57908 6.3407 2.16754 8.57006 1.44317C10.7994 0.718811 13.2009 0.718812 15.4302 1.44318C17.6596 2.16754 19.6024 3.57908 20.9802 5.47549"
      stroke="#51526C"
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <path
      d="M23.0999 12C23.0999 14.3441 22.3578 16.628 20.98 18.5244C19.6021 20.4208 17.6593 21.8324 15.43 22.5567C13.2006 23.2811 10.7991 23.2811 8.56978 22.5567C6.34041 21.8324 4.3976 20.4208 3.01978 18.5244"
      stroke="#51526C"
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <rect x="1.5022" y="17.0999" width="1.5" height="1.5" fill="#51526C" />
    <rect x="21.0022" y="5.24951" width="1.5" height="1.5" fill="#51526C" />
  </svg>
</template>

<style scoped></style>
